<template>
  <div class="container-table-striped w-100 mt-4">
    <div class="table-hover">
      <table class="table content-table-striped">
        <thead>
          <tr class="row global-thead-dark thead-property">
            <th class="col-12 text-center main-title">
              Evaluaciones de Servicios
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.analysisServiceId" class="row">
            <td class="col-md-12">
              <div class="row col-md-12 mt-n3 pl-3 pt-4 d-flex">
                <div class="col-md-3  flex-grow-1 flex-shrink-1">
                  <div class="text-box">
                    <StrongTitle title="Servicio: " />
                    <span>
                      {{
                        item.peiAnalysisServiceCode ==
                        peiAnalysisServiceCodes.Otros
                          ? 'Otros - ' + item.service
                          : item.service
                      }}
                    </span>
                  </div>
                  <div v-if="showModality(item)" class="text-box">
                    <StrongTitle title="Modalidad: " />
                    <span>{{ item.modality }}</span>
                  </div>
                  <div v-if="showProvisionalRemedy(item)" class="text-box">
                    <StrongTitle title="Remedio Provisional: " />
                    <span>
                      {{
                        item.provisionalRemedy
                          ? 'Si'
                          : item.provisionalRemedyFlag == null
                          ? ''
                          : 'No'
                      }}
                    </span>
                  </div>
                  <div
                    v-if="
                      item.peiAnalysisServiceCode ==
                        peiAnalysisServiceCodes.Educativo
                    "
                    class="text-box"
                  >
                    <StrongTitle title="Tipo de enfoque: " />
                    <span>{{ item.focusType }}</span>
                  </div>
                </div>
                <div class="col-md-3 flex-grow-1 flex-shrink-1">
                  <div class="text-box">
                    <StrongTitle title="Frecuencia: " />
                    <span>{{ item.frequency }}</span>
                  </div>
                  <div class="text-box">
                    <StrongTitle title="Duración: " />
                    <span>{{ item.therapyDuration }}</span>
                  </div>
                  <div v-if="showTeacherType(item)" class="text-box">
                    <StrongTitle title="Tipo de Maestro:" />
                    <span>{{ item.peiTeacherTypeDescription }}</span>
                  </div>
                  <div v-if="item.startDate" class="text-box">
                    <StrongTitle title="Desde: " />
                    <span>{{ formatDate(item.startDate) }}</span>
                  </div>
                  <div v-if="item.endDate" class="text-box">
                    <StrongTitle title="Hasta: " />
                    <span>{{ formatDate(item.endDate) }}</span>
                  </div>
                </div>

                <div class="col-md-2 flex-grow-1 flex-shrink-1">
                  <div v-if="showSchoolshipDetails(item)" class="text-box">
                    <StrongTitle title="Partida: " />
                    <span>{{ item.startingPlace }}</span>
                  </div>
                  <div v-if="showSchoolshipDetails(item)" class="text-box">
                    <StrongTitle title="Lugar: " />
                    <span>{{ item.place }}</span>
                  </div>
                </div>

                <div class="col-md-3 flex-grow-1 flex-shrink-1">
                  <div v-if="showTransportField(item)" class="text-block">
                    <StrongTitle title="Transportación: " />
                    <span>
                      {{
                        item.transportation == null && item.isCompletedFlag
                          ? 'No es necesario'
                          : item.transportation == null
                          ? ''
                          : item.transportation
                      }}
                    </span>
                  </div>
                  <div
                    v-if="
                      showTransportationInfo(item) &&
                        item.codeNo == peiCode.Porteador
                    "
                    class="text-box"
                  >
                    <StrongTitle title="Equipo Especial: " />
                    <span>{{ item.specialEquipment }}</span>
                  </div>
                  <div
                    v-if="
                      showTransportationInfo(item) &&
                        (item.codeNo == peiCode.Porteador ||
                          item.codeNo == peiCode.Beca)
                    "
                    class="text-box"
                  >
                    <StrongTitle title="Acompañante: " />
                    <span>
                      {{
                        item.companion
                          ? 'Si'
                          : item.companion == null
                          ? ''
                          : 'No'
                      }}
                    </span>
                  </div>
                  <div
                    v-if="
                      showTransportationInfo(item) &&
                        item.codeNo == peiCode.Beca
                    "
                    class="text-box"
                  >
                    <StrongTitle title="Millaje: " />
                    <span>{{ item.mileage }}</span>
                  </div>
                </div>

                <div class="col-md-1 flex-fill text-right">
                  <button
                    v-if="
                      canEdit &&
                        (canUseTabEditRestriction.some(
                          (element) =>
                            element.serviceId ===
                            item.serviceContinuityCheckData.disciplineTypeId
                        ) ||
                          !canUseNewLogic)
                    "
                    class="btn btn-dropdown-actions dropdown-toggle pt-1"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span>Acciones</span>
                  </button>
                  <div class="dropdown-menu dropdown-menu-right pb-0">
                    <a
                      v-if="viewEdit()"
                      class="drop-item"
                      @click="edit(item, 'Edit')"
                    >
                      <i class="fas fa-edit text-green pr-2" />
                      <span>Editar</span>
                    </a>
                    <a
                      v-if="!viewEdit()"
                      class="drop-item"
                      @click="edit(item, 'Details')"
                    >
                      <i class="fas fa-edit text-green pr-2" />
                      <span>Ver Detalle</span>
                    </a>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  validationTriggered.validation &&
                    validationTriggered.hasErrors(
                      'Tab8',
                      `PAS-COG-${item.analysisServiceId}`
                    )
                "
                class="row pl-3 mt-3"
              >
                <div class="col-md-12">
                  <Error
                    message="Al seleccionar que el estudiante tiene impedimento cognoscitivo debe contestar Si a la pregunta ¿Tiene el estudiante un impedimento significativo el cual requiere que se recoja directamente en su hogar?"
                    variant="no-border"
                  />
                </div>
              </div>
              <div
                v-if="
                  validationTriggered.validation &&
                    validationTriggered.hasErrors(
                      'Tab8',
                      `PAS-EDU-${item.analysisServiceId}`
                    )
                "
                class="row pl-3 mt-3"
              >
                <div class="col-md-12">
                  <Error
                    message="Al seleccionar que el estudiante cuenta con una alternativa de ubicación en Hogar, Hospital o Corrección la modalidad debe ser Hogar."
                    variant="no-border"
                  />
                </div>
              </div>
              <div
                v-if="
                  validationTriggered.validation &&
                    validationTriggered.hasErrors(
                      'Tab8',
                      `STC-${item.analysisServiceId}`
                    )
                "
                class="row pl-3 mt-3"
              >
                <div class="col-md-12">
                  <Error
                    :message="resources['R03200125']"
                    variant="no-border"
                  />
                </div>
              </div>
              <div
                v-if="
                  validationTriggered.validation &&
                    validationTriggered.hasErrors(
                      'Tab8',
                      `SIQ-${item.analysisServiceId}`
                    )
                "
                class="row pl-3 mt-3"
              >
                <div class="col-md-12">
                  <Error :message="resources['R9260071']" variant="no-border" />
                </div>
              </div>
              <div
                v-if="
                  validationTriggered.validation &&
                    validationTriggered.hasErrors(
                      'Tab8',
                      `STQ-${item.analysisServiceId}`
                    )
                "
                class="row pl-3 mt-3"
              >
                <div class="col-md-12">
                  <Error :message="resources['R040001']" variant="no-border" />
                </div>
              </div>
              <div
                v-if="
                  validationTriggered.validation &&
                    validationTriggered.hasErrors(
                      'Tab8',
                      `STD-${item.analysisServiceId}`
                    )
                "
                class="row pl-3 mt-3"
              >
                <div class="col-md-12">
                  <Error
                    :message="resources['R03200126']"
                    variant="no-border"
                  />
                </div>
              </div>
              <div
                v-if="
                  validationTriggered.validation &&
                    validationTriggered.hasErrors(
                      'Tab8',
                      `COG-${item.analysisServiceId}`
                    )
                "
                class="row pl-3 mt-3"
              >
                <div class="col-md-12">
                  <Error
                    :message="
                      validationTriggered.errors(
                        'Tab8',
                        `COG-${item.analysisServiceId}`
                      )
                    "
                    variant="no-border"
                  />
                </div>
              </div>
              <div
                v-if="
                  showTransportField(item) &&
                    validationTriggered.validation &&
                    (item.transportationRequiredFlag == null ||
                      (item.transportationRequiredFlag == true &&
                        !item.hasTransportRequestQuestionaire))
                "
                class="row pl-3 mt-3"
              >
                <div class="col-md-12">
                  <Error
                    message="Debe completar la información relacionada a Transportación Escolar."
                    variant="no-border"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <Error
                    v-if="
                      item.isCompletedFlag == false ||
                        item.needsEvaluations == true
                    "
                    :message="resources['23011']"
                    is-alert-mode
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <Error
                    v-if="
                      item.transportationRequiredFlag &&
                        item.transportationRequiredFlag == true &&
                        !item.hasTransportRequestQuestionaire &&
                        !isPS
                    "
                    :is-alert-mode="true"
                    :message="resources['P90003']"
                  />
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="items.length == 0" class="row">
            <td class="col text-center">
              <span class="empty-rows">
                Actualmente no se han registrado datos en el Plan de Servicio
                del Estudiante
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import store from '@/store/index';
import { StrongTitle } from '@/components/pei/tabs/components/tab6';
import Error from '@/components/common/Error.vue';
import resourcesService from '@/services/resources.js';
import PeiStatus from '@/utils/constants/pei/peiStatus';
import PeiProgramAreas from '@/utils/constants/pei/peiProgramAreas';
import PeiAnalysisServiceCodes from '@/utils/constants/pei/peiAnalysisService';
import generalService from '@/services/pei/general';
import PeiCode from '@/utils/constants/pei/peiCode';
import mixAlert from '@/mixin/alert.mixin';
import moment from 'moment';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import peiTeacherType from '@/utils/constants/pei/peiTeacherType';
import academicYears from '@/utils/constants/academicYears';

const TRANSPORTACION = 1937;

export default {
  name: 'Tab8Service',
  mixins: [mixAlert],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    enableEdit: {
      type: Boolean,
      default: true,
    },
    isDraft: {
      type: Boolean,
      default: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      resources: [],
      peiId: this.$store.getters.SelectedPei,
      pei: {},
      peiProgramAreas: PeiProgramAreas,
      peiCode: PeiCode,
      peiAnalysisServiceCodes: PeiAnalysisServiceCodes,
      isPS: store.getters.getIsPs,
      activateAssistantServiceNeedGuideIsOn: false,
    };
  },
  computed: {
    validationTriggered() {
      return this.$store.getters.getPeiValidationTriggered;
    },
    getCheckId() {
      return (item) => `provisionalRemedy${item.analysisServiceId}`;
    },
    canUseTabEditRestriction() {
      return this.$store.state['$_admendment'].sectionsServices;
    },
    canUseNewLogic() {
      return (
        this.$store.state['$_admendment'].correlationParameter[0]
          .staticValue === 'true'
      );
    },
  },
  async activated() {
    await this.loadDataToValidate();
  },
  methods: {
    showProvisionalRemedy(item) {
      let notSupportedServices = [
        PeiAnalysisServiceCodes.Educativo,
        PeiAnalysisServiceCodes.ServicioCiegos,
        PeiAnalysisServiceCodes.ServicioSordos,
        PeiAnalysisServiceCodes.LenguajeSenas,
        PeiAnalysisServiceCodes.EducacionFisicaAdaptadaCombinada,
        PeiAnalysisServiceCodes.EducacionFisicaAdaptada,
        PeiAnalysisServiceCodes.ConsejeriaRehabilitacion,
        PeiAnalysisServiceCodes.Otros,
      ];
      return !notSupportedServices.some(
        (a) => a == item.peiAnalysisServiceCode
      );
    },
    showTeacherType(item) {
      let sopportedServices = [
        PeiAnalysisServiceCodes.EducacionFisicaAdaptada,
        PeiAnalysisServiceCodes.EducacionFisicaAdaptadaCombinada,
        PeiAnalysisServiceCodes.ServicioSordos,
        PeiAnalysisServiceCodes.ServicioCiegos,
        PeiAnalysisServiceCodes.ConsejeriaRehabilitacion,
      ];

      return sopportedServices.some(
        (serviceId) => serviceId == item.peiAnalysisServiceCode
      );
    },
    showSchoolshipDetails(item) {
      let allowedTransportationTypes = [
        PeiCode.Regular,
        PeiCode.Porteador,
        PeiCode.Beca,
      ];

      let isAllowedTransportType = allowedTransportationTypes.some(
        (typeId) => typeId == item.codeNo
      );

      let isSopportedService = this.showTransportationInfo(item);

      return isAllowedTransportType && isSopportedService;
    },
    showTransportField(item) {
      let notSupportedServices = [
        PeiAnalysisServiceCodes.ServicioSordos,
        PeiAnalysisServiceCodes.LenguajeSenas,
        PeiAnalysisServiceCodes.ServicioCiegos,
        PeiAnalysisServiceCodes.EducacionFisicaAdaptada,
        PeiAnalysisServiceCodes.EducacionFisicaAdaptadaCombinada,
        PeiAnalysisServiceCodes.ConsejeriaRehabilitacion,
      ];

      return this.showTransportationInfo(item, notSupportedServices);
    },
    showTransportationInfo(item, args) {
      let notSupportedServices = [
        PeiAnalysisServiceCodes.ServicioSordos,
        PeiAnalysisServiceCodes.LenguajeSenas,
        PeiAnalysisServiceCodes.ServicioCiegos,
        PeiAnalysisServiceCodes.EducacionFisicaAdaptada,
        PeiAnalysisServiceCodes.EducacionFisicaAdaptadaCombinada,
        PeiAnalysisServiceCodes.ConsejeriaRehabilitacion,
      ];

      if (args && args.length > 0) {
        notSupportedServices = args;
      }

      return !notSupportedServices.some(
        (serviceId) => serviceId == item.peiAnalysisServiceCode
      );
    },
    showModality(item) {
      let unSupportedServices = [
        PeiAnalysisServiceCodes.ServicioSordos,
        PeiAnalysisServiceCodes.ServicioCiegos,
        PeiAnalysisServiceCodes.LenguajeSenas,
        PeiAnalysisServiceCodes.ConsejeriaRehabilitacion,
      ];

      if (
        item.peiTeacherTypeCode == peiTeacherType.Itinerante &&
        store.getters.getPeiInfo.academicYearId >= academicYears.Y2026_2027
      ) {
        unSupportedServices = [PeiAnalysisServiceCodes.LenguajeSenas];
      }

      return !unSupportedServices.some(
        (serviceId) => serviceId == item.peiAnalysisServiceCode
      );
    },
    async loadDataToValidate() {
      const academicYearId = store.getters.getPeiInfo.academicYearId;
      const { data } = await getSysparameterByNames({
        parameterNames: ['ActivateAssistantServiceNeedGuide'],
        academicYearId,
      });
      this.activateAssistantServiceNeedGuideIsOn =
        data[0]?.staticValue == 'true';
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    view(item) {
      this.$emit('view', item);
    },
    edit(item, Action) {
      if (
        Action == 'Edit' &&
        this.enableEdit == false &&
        store.getters.getIsPs == false &&
        store.getters.getPeiInfo.peiLocationRejected == false
      ) {
        this.$ApiGet('/api/validationsmessages/', {
          messageCodes: '22114',
        }).then((response) => {
          let msj = response.data.shift();
          this.ShowToast('Advertencia', msj.name, 'warning');
        });
        return;
      }

      this.$emit('edit', item);
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '23011',
        'R03200126',
        'R03200125',
        'R9260071',
        'P90001',
        'P90003',
        'R040001',
      ]);
    },
    async getPei() {
      this.$ApiGet('/api/pei/getpei?peiId=' + this.peiId)
        .then((res) => {
          this.pei = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    viewEdit() {
      return store.getters.getPeiInfo.peiStatusCode == PeiStatus.Borrador;
    },
  },
  components: {
    StrongTitle,
    Error,
  },
  async mounted() {
    this.loadResources();
    await this.loadDataToValidate();
  },
  created() {},
};
</script>

<style scoped>
.main-title {
  text-align: left;
  font: Bold 18px/29px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
}

.text-box {
  width: 350px;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
  cursor: pointer;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.empty-rows {
  color: #808080;
  text-align: center;
}

.box-width {
  width: 20%;
}
</style>
